import ApiService from './ApiService'

export async function apiGetVisualCheckTemplates(params) {
	return ApiService.fetchData({
		url: 'visual_check_templates',
		method: 'get',
		params,
	})
}

export async function apiGetVisualCheckTemplate(id) {
	return ApiService.fetchData({
		url: `visual_check_templates/${id}`,
		method: 'get',
	})
}

export async function apiPostVisualCheckTemplate(formData) {
	return ApiService.fetchData({
		url: 'visual_check_templates',
		method: 'post',
		data: formData,
	})
}

// Laravel no parsea multipart/form-data en requests PUT nativos (PHP no llena
// $_FILES), así que las actualizaciones con archivos van por POST + _method=PUT
// (method spoofing estándar de Laravel) en vez de method: 'put'.
export async function apiPutVisualCheckTemplate(id, formData) {
	formData.append('_method', 'PUT')
	return ApiService.fetchData({
		url: `visual_check_templates/${id}`,
		method: 'post',
		data: formData,
	})
}

export async function apiDeleteVisualCheckTemplate(id) {
	return ApiService.fetchData({
		url: `visual_check_templates/${id}`,
		method: 'delete',
	})
}

// Sandbox de prueba — solo disponible para templates ya guardados (necesita
// un id real). Ver docs/FEATURE-VALIDACION-VISUAL-IA.md sección 8.
export async function apiTestVisualCheckTemplate(id, formData) {
	return ApiService.fetchData({
		url: `visual_check_templates/${id}/test`,
		method: 'post',
		data: formData,
	})
}
